import React, {Component} from 'react';

import queryString from 'query-string';

import FlyengParent from './flyEng/Child/index.js';
import TomoplayParent from './Tomoplay/Child/index.js';


class MngrChild extends Component {


	constructor(props) {
		super(props);

		const query =  queryString.parse(this.props.location.search);
		const view = query.view || "list";

		this.state= {
			view : view,
			query : query,
            page : "tomoplay"
		};

	}

	changePage = (e) => {
        this.setState({page: e})
    }


	render() {
		const serviceList = [{name:"통합 원아", value:"tomoplay"}, {name:"플라잉", value:"flyeng"}];

		const {
            view,
			query,
			page
        } = this.state;
			return (
				<div className="dashboard-wrapper">
	                <div className="dashboard-ecommerce">
                		<div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
							<div className="row">
								<h2 className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-4pageheader-title">
									원아 코드 관리
								</h2>
								<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
									<select className="form-control form-control-lg" name="month" value={page} onChange={(e) => this.changePage(e.target.value)} style={{ fontSize: "1.3em" }}>
										{serviceList.map((s) => <option value={s.value}>{s.name}</option>)}
									</select>
								</div>
							</div>
						</div>
	                </div>
					{this.state.page == "flyeng" ? (<FlyengParent view={view} query={query}/>) : (<TomoplayParent view={view} query={query}/>)}
	            </div>
			)	
		} 

}
export default MngrChild;